const e = {
  id: "TristatePick4",
  name: "Pick 4",
  style: {
    colorPrimary: "#1fbfed"
  }
};
export {
  e as default
};
